module.exports = __webpack_public_path__ + "static/media/ie-university-white.2dcd36a0.svg";